import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomOurBrandsComponentData } from '../custom-our-brands/custom-our-brands.model';
import { CmsService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomDoubleBannerModel } from "./custom-double-banner.model";

@Component({
  selector: 'app-custom-double-banner',
  templateUrl: './custom-double-banner.component.html',
  styleUrls: ['./custom-double-banner.component.scss'],
  standalone: false
})
export class CustomDoubleBannerComponent implements OnInit {

  constructor(
    private componentData: CmsComponentData<CustomDoubleBannerModel>,
    private cmsService: CmsService
  ) {
  }

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));

  ngOnInit(): void {
  }

}
